// Rechtstexte (Entwurf). Unbekannte Angaben sind als [Platzhalter] markiert und müssen ergänzt werden.
export const COMPANY = {
  name: "PILATES ON.",
  owner: "Passion GbR",
  street: "Kapellenstraße 55",
  city: "88471 Laupheim",
  country: "Deutschland",
  email: "office@pilateson.de",
  vatId: "[USt-IdNr., falls vorhanden]",
  register: "[Registergericht / HRB, falls eingetragen]",
  domain: "pilateson.de",
};

const addr = `${COMPANY.name}\n${COMPANY.owner}\n${COMPANY.street}\n${COMPANY.city}\n${COMPANY.country}`;

export const LEGAL = {
  impressum: [
    { h: "Angaben gemäß § 5 TMG / § 18 MStV", p: [addr] },
    { h: "Kontakt", p: [`E-Mail: ${COMPANY.email}`] },
    { h: "Umsatzsteuer-ID", p: [`Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG: ${COMPANY.vatId}`] },
    { h: "Registereintrag", p: [COMPANY.register] },
    { h: "Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV", p: [`${COMPANY.owner}, ${COMPANY.street}, ${COMPANY.city}`] },
    {
      h: "Haftung für Inhalte",
      p: [
        "Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.",
        "Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden entsprechender Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.",
      ],
    },
    {
      h: "Haftung für Links",
      p: [
        "Unser Angebot enthält ggf. Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.",
      ],
    },
    {
      h: "Urheberrecht",
      p: [
        "Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.",
      ],
    },
    {
      h: "Hinweis zu Produktabbildungen",
      p: ["Abbildungen dienen der Veranschaulichung. Farbdarstellungen können abweichen. Alle Preise auf Anfrage; es handelt sich nicht um einen Online-Shop."],
    },
  ],
  datenschutz: [
    {
      h: "1. Verantwortlicher",
      p: [`Verantwortlich für die Datenverarbeitung auf dieser Website ist:\n${addr}\nE-Mail: ${COMPANY.email}`],
    },
    {
      h: "2. Allgemeine Hinweise",
      p: [
        "Der Schutz deiner persönlichen Daten ist uns wichtig. Wir verarbeiten personenbezogene Daten ausschließlich im Rahmen der gesetzlichen Bestimmungen (DSGVO, BDSG, TTDSG). Diese Datenschutzerklärung informiert darüber, welche Daten wir erheben, wofür wir sie nutzen und welche Rechte dir zustehen.",
      ],
    },
    {
      h: "3. Hosting und Server-Logfiles",
      p: [
        "Beim Aufruf der Website verarbeitet der Hosting-Anbieter automatisch Informationen in sogenannten Server-Logfiles (IP-Adresse, Datum und Uhrzeit, aufgerufene Seite, Browsertyp, Betriebssystem, Referrer-URL). Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO zur Sicherstellung eines störungsfreien Betriebs und zur Sicherheit der Website. Die Daten werden nicht mit anderen Datenquellen zusammengeführt.",
      ],
    },
    {
      h: "4. Anfrage- und Kontaktformulare",
      p: [
        "Wenn du uns über ein Formular (Angebots-, Projekt- oder Kontaktanfrage) kontaktierst, werden die eingegebenen Daten (z. B. Name, Unternehmen, E-Mail-Adresse, Telefonnummer, Ort, Kundentyp, gewünschtes Produkt und Edition, Stückzahl, Nachricht) zur Bearbeitung der Anfrage und für Anschlussfragen bei uns gespeichert. Zusätzlich erhalten wir eine automatische E-Mail-Benachrichtigung über den Eingang deiner Anfrage.",
        "Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen) sowie Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der Bearbeitung von Anfragen). Die Daten werden gelöscht, sobald sie für die Bearbeitung nicht mehr erforderlich sind und keine gesetzlichen Aufbewahrungspflichten entgegenstehen.",
      ],
    },
    {
      h: "5. Formularversand über Web3Forms",
      p: [
        "Für die Übermittlung unserer Kontakt-, Angebots- und Projektanfragen nutzen wir Web3Forms. Beim Absenden eines Formulars werden die von dir eingegebenen Daten an Web3Forms übermittelt und zur Zustellung der Anfrage an uns verarbeitet. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen) sowie Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer zuverlässigen Bearbeitung von Anfragen). Weitere Informationen zum Datenschutz des Dienstes findest du unter web3forms.com/privacy.",
      ],
    },
    {
      h: "7. Cookies und lokale Speicherung",
      p: [
        "Diese Website setzt keine Tracking- oder Marketing-Cookies ein und verwendet derzeit keine Analyse-Tools. Zur Speicherung deiner Sprachauswahl wird ein technisch notwendiger Eintrag im lokalen Speicher deines Browsers (localStorage) abgelegt. Im passwortgeschützten Verwaltungsbereich kann ein technisch notwendiges Sitzungs-Cookie verwendet werden.",
      ],
    },
    {
      h: "8. Deine Rechte",
      p: [
        "Du hast das Recht auf Auskunft (Art. 15 DSGVO), Berichtigung (Art. 16), Löschung (Art. 17), Einschränkung der Verarbeitung (Art. 18), Datenübertragbarkeit (Art. 20) sowie Widerspruch gegen die Verarbeitung (Art. 21 DSGVO). Eine erteilte Einwilligung kannst du jederzeit mit Wirkung für die Zukunft widerrufen. Außerdem hast du das Recht, dich bei einer Datenschutz-Aufsichtsbehörde zu beschweren; zuständig ist u. a. der Landesbeauftragte für den Datenschutz und die Informationsfreiheit Baden-Württemberg.",
        `Zur Ausübung deiner Rechte genügt eine E-Mail an ${COMPANY.email}.`,
      ],
    },
    {
      h: "9. Aktualität",
      p: ["Diese Datenschutzerklärung ist aktuell gültig und hat den Stand September 2026. Durch die Weiterentwicklung unserer Website oder aufgrund geänderter gesetzlicher Vorgaben kann eine Anpassung erforderlich werden."],
    },
  ],
  agb: [
    {
      h: "1. Geltungsbereich",
      p: [
        `Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Angebote, Lieferungen und Leistungen von ${COMPANY.name}, ${COMPANY.street}, ${COMPANY.city} (nachfolgend „PILATES ON.“) gegenüber Kunden. Abweichende Bedingungen des Kunden werden nur anerkannt, wenn PILATES ON. ihrer Geltung ausdrücklich schriftlich zugestimmt hat.`,
      ],
    },
    {
      h: "2. Keine Online-Bestellung – Angebot und Vertragsschluss",
      p: [
        "Die Darstellung der Produkte auf dieser Website stellt kein rechtlich bindendes Angebot dar, sondern dient der Information und der Vorbereitung einer individuellen Anfrage. Über die Website können keine verbindlichen Bestellungen aufgegeben und keine Zahlungen getätigt werden.",
        "Auf eine Anfrage hin erstellt PILATES ON. ein individuelles, schriftliches Angebot (z. B. per E-Mail). Ein Vertrag kommt erst durch die Annahme dieses Angebots durch den Kunden bzw. durch die schriftliche Auftragsbestätigung von PILATES ON. zustande.",
      ],
    },
    {
      h: "3. Preise und Zahlung",
      p: [
        "Alle Preise ergeben sich ausschließlich aus dem individuellen Angebot. Die Zahlungsbedingungen (z. B. Anzahlung, Fälligkeit, Zahlungsart) werden im jeweiligen Angebot bzw. in der Auftragsbestätigung festgelegt.",
      ],
    },
    {
      h: "4. Lieferung",
      p: [
        "Lieferumfang, Lieferort, Lieferzeit sowie Kosten für Versand, Transport und ggf. Aufbau werden im individuellen Angebot geregelt. Angaben zu Lieferzeiten sind unverbindlich, sofern sie nicht ausdrücklich als verbindlich vereinbart wurden.",
      ],
    },
    {
      h: "5. Produktabbildungen und Editionen",
      p: [
        "Abbildungen, Farbdarstellungen und Maßangaben auf der Website dienen der Veranschaulichung. Die Editionen (Natural, Walnut, Ivory, Obsidian, Blush) beschreiben ausschließlich die Design-, Farb- und Materialausführung; handelsübliche, materialbedingte Abweichungen (insbesondere bei Naturholz) stellen keinen Mangel dar.",
      ],
    },
    {
      h: "6. Eigentumsvorbehalt",
      p: ["Gelieferte Ware bleibt bis zur vollständigen Bezahlung Eigentum von PILATES ON."],
    },
    {
      h: "7. Gewährleistung und Haftung",
      p: [
        "Es gelten die gesetzlichen Gewährleistungsrechte. Gegenüber Unternehmern beträgt die Gewährleistungsfrist ein Jahr ab Ablieferung, soweit nicht zwingende gesetzliche Vorschriften entgegenstehen. PILATES ON. haftet unbeschränkt für Vorsatz und grobe Fahrlässigkeit sowie bei Verletzung von Leben, Körper oder Gesundheit; im Übrigen ist die Haftung auf den vertragstypisch vorhersehbaren Schaden begrenzt.",
      ],
    },
    {
      h: "8. Schlussbestimmungen",
      p: [
        "Es gilt das Recht der Bundesrepublik Deutschland unter Ausschluss des UN-Kaufrechts. Ist der Kunde Kaufmann, juristische Person des öffentlichen Rechts oder öffentlich-rechtliches Sondervermögen, ist Gerichtsstand der Sitz von PILATES ON. Sollten einzelne Bestimmungen unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.",
      ],
    },
  ],
  widerruf: [
    {
      h: "Hinweis",
      p: [
        "Über diese Website werden keine Verträge geschlossen; Verträge kommen ausschließlich auf Grundlage eines individuellen Angebots zustande. Schließt ein Verbraucher (§ 13 BGB) mit PILATES ON. einen Vertrag ausschließlich über Fernkommunikationsmittel (z. B. E-Mail), steht ihm das nachfolgende Widerrufsrecht zu. Unternehmern steht kein gesetzliches Widerrufsrecht zu.",
      ],
    },
    {
      h: "Widerrufsrecht",
      p: [
        "Du hast das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen. Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag, an dem du oder ein von dir benannter Dritter, der nicht der Beförderer ist, die Waren in Besitz genommen hast bzw. hat.",
        `Um dein Widerrufsrecht auszuüben, musst du uns (${COMPANY.name}, ${COMPANY.street}, ${COMPANY.city}, E-Mail: ${COMPANY.email}) mittels einer eindeutigen Erklärung (z. B. ein mit der Post versandter Brief oder eine E-Mail) über deinen Entschluss, diesen Vertrag zu widerrufen, informieren. Zur Wahrung der Widerrufsfrist reicht es aus, dass du die Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absendest.`,
      ],
    },
    {
      h: "Folgen des Widerrufs",
      p: [
        "Wenn du diesen Vertrag widerrufst, haben wir dir alle Zahlungen, die wir von dir erhalten haben, einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass du eine andere Art der Lieferung als die von uns angebotene, günstigste Standardlieferung gewählt hast), unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über deinen Widerruf dieses Vertrags bei uns eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das du bei der ursprünglichen Transaktion eingesetzt hast, es sei denn, mit dir wurde ausdrücklich etwas anderes vereinbart.",
        "Wir können die Rückzahlung verweigern, bis wir die Waren wieder zurückerhalten haben oder bis du den Nachweis erbracht hast, dass du die Waren zurückgesandt hast, je nachdem, welches der frühere Zeitpunkt ist. Du hast die Waren unverzüglich und in jedem Fall spätestens binnen vierzehn Tagen ab dem Tag, an dem du uns über den Widerruf dieses Vertrags unterrichtest, an uns zurückzusenden oder zu übergeben. Du trägst die unmittelbaren Kosten der Rücksendung der Waren; bei Waren, die aufgrund ihrer Beschaffenheit nicht normal mit der Post zurückgesandt werden können (z. B. Reformer), werden die Kosten der Rücksendung im individuellen Angebot ausgewiesen.",
        "Du musst für einen etwaigen Wertverlust der Waren nur aufkommen, wenn dieser Wertverlust auf einen zur Prüfung der Beschaffenheit, Eigenschaften und Funktionsweise der Waren nicht notwendigen Umgang mit ihnen zurückzuführen ist.",
      ],
    },
    {
      h: "Ausschluss des Widerrufsrechts",
      p: [
        "Das Widerrufsrecht besteht nicht bei Verträgen zur Lieferung von Waren, die nicht vorgefertigt sind und für deren Herstellung eine individuelle Auswahl oder Bestimmung durch den Verbraucher maßgeblich ist oder die eindeutig auf die persönlichen Bedürfnisse des Verbrauchers zugeschnitten sind (§ 312g Abs. 2 Nr. 1 BGB).",
      ],
    },
    {
      h: "Muster-Widerrufsformular",
      p: [
        `(Wenn du den Vertrag widerrufen willst, dann fülle bitte dieses Formular aus und sende es zurück.)\n\nAn ${COMPANY.name}, ${COMPANY.street}, ${COMPANY.city}, E-Mail: ${COMPANY.email}\n\nHiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über den Kauf der folgenden Waren (*) / die Erbringung der folgenden Dienstleistung (*)\nBestellt am (*) / erhalten am (*)\nName des/der Verbraucher(s)\nAnschrift des/der Verbraucher(s)\nUnterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier)\nDatum\n\n(*) Unzutreffendes streichen.`,
      ],
    },
  ],
};
